import { useCallback, useContext, useEffect, useState } from "react";
import ticketGenerate from "../../app/ticket/ticketGenerate";
import { EeljProps } from "../eelj/EeljInfo";
import { updateOrder, uploadHealth, getOrderCheck, getContract } from "../../app/api";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../providers/UserProvider";

export enum PaymentStatus {
  paid = "Төлсөн",
  unpaid = "Төлөөгүй",
  wait = "Хүлээгдэж байгаа",
  cancelled = "Цуцалсан",
  barter = "Бартер",
  collective = "Анги хамт олон"
}

export type OrderProps = {
  id: string
  userRole: string | undefined;
  eelj: EeljProps;
  paymentStatus: string;
  qpayData: any;
  healthCertificate: string;
  userStatus: string;
  group: {
    user: any;
    group: any;
    register_at: Date,
  },
  register: {
    user: any;
    register_at: string;
  }[];
  register_admin: {
    user: any;
    register_at: string;
  }[];
  register_group: {
    user: any;
    group: any;
    register_at: string;
  }[];
  ebarimt: any;
  ticket_id: number;

  qpayDataIT: any;
  geree: boolean;
};

export const OrderInfo = (props: OrderProps) => {
  const { userBio } = useContext(UserContext);
  const [orderData, setOrderData] = useState<OrderProps>(props);
  const [healthImg, setHealthImg] = useState<any | undefined>(undefined);
  const [healthImgError, setHealthImgError] = useState<string | undefined>(undefined);
  const [healthImgResponse, setHealthImgResponse] = useState<string | undefined>(undefined);
  const { id, userRole, eelj, paymentStatus, qpayData, qpayDataIT, healthCertificate, userStatus, group, register, register_admin, register_group, ticket_id, ebarimt, geree } = orderData;

  const [agreed, setAgreed] = useState(false);



  const changePaymentStatus = (status: string) => {
    setOrderData({
      ...orderData,
      paymentStatus: status,
    });
  };

  const checkPayment = async () => {
    const orderCheck = await getOrderCheck(id);
    if (orderCheck.data.paymentStatus === PaymentStatus.wait) {
      alert("Төлбөр хийгдээгүй байна.");
      return;
    }

    changePaymentStatus(orderCheck.data.paymentStatus);

  };

  const handleTicket = useCallback(async () => {
    if (userBio && eelj) {
      try {
        await ticketGenerate.generatePDF(userBio, userBio.image, eelj, ticket_id, ebarimt);
      } catch (err) {
        console.log(err);
      }
    }
  }, [userBio, eelj]);

  const handleHealthImageUpdate = useCallback(async (image: File) => {
    setHealthImgResponse(undefined);
    setHealthImgError(undefined);
    try {
      const formData = new FormData();
      formData.set('order_id', id);
      formData.set('image', image);

      const resp = await uploadHealth(formData);
      setHealthImgResponse('Амжилттай');
      setHealthImgError(undefined);
    } catch (err: any) {
      const resp = err.response;
      setHealthImg(undefined);
      if (resp.data.error) {
        setHealthImgError(resp.data.error);
      } else {
        setHealthImgError('Зураг шинэчлэхэд алдаа гарлаа.');
      }
    }
  }, [id]);

  const handleUpdateOrder = useCallback(async (register_type: string) => {
    try {
      const resp = await updateOrder(id, {
        register_type: register_type
      });

      setOrderData((v) => {
        return {
          ...v,
          ...resp.data,
        };
      })
    } catch (err: any) {
      alert(err.response.data.error);
    }
  }, [id]);

  useEffect(() => {
    if (agreed && !geree) {
      getContract(id);
    }
  }, [agreed]);


  return (
    <div>
      <div className="bg-[#F8F8FF] border-[1px] border-[#cecece] rounded-lg p-4 mb-6">
        <p className="text-[#003463] text-md font-bold">{eelj?.title}</p>
        {(paymentStatus === PaymentStatus.paid || paymentStatus === PaymentStatus.barter || paymentStatus === PaymentStatus.collective) &&
          <div className="flex max-[600px]:flex-col max-[600px]:items-center">
            <div className="max-[600px]:mt-4 flex flex-col md:flex-row justify-between items-center">
              <div className="text-[#003463] w-full md:w-[40%]">
                <p>
                  Таны худалдан авалт амжилттай бүртгэгдлээ. Гэрээтэй танилцаж QR код бүхий эрхийн бичгээ татаж авна уу.
                </p>

                <div className="mt-4 space-y-2">
                  <div>
                    <span className="font-semibold">Гэрээ:</span>{' '}
                    <a
                      target="_blank"
                      href="/contract.pdf"
                      download="/contract.pdf"
                      className="text-blue-600 underline hover:text-blue-800"
                    >
                      📄 Гэрээ татах
                    </a>
                  </div>
                  <div>
                    <span className="font-semibold">Амралтанд мөрдөх дэг:</span>{' '}
                    <a
                      target="_blank"
                      href="/deg.pdf"
                      download="/deg.pdf"
                      className="text-blue-600 underline hover:text-blue-800"
                    >
                      📄 Татах
                    </a>
                  </div>
                </div>
              </div>

              {userRole === 'user' ?
                <div>

                  {(!geree || geree === undefined || geree === null) &&
                    <>
                      <label className="flex items-center gap-2 mb-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={agreed}
                          onChange={() => setAgreed(prev => !prev)}
                          className="w-4 h-4"
                        />
                        <span className="text-sm text-[#003463]">Би гэрээтэй танилцаж, зөвшөөрч байна</span>
                        <a
                          target="_blank"
                          download="/contract.pdf"
                          className="font-bold text-[#003463]"
                          href="/contract.pdf"
                        >
                          энд дарж
                        </a>{" "}
                        татаж авна уу.
                      </label>
                    </>
                  }

                  {(geree || agreed) &&
                    <>
                      <div onClick={handleTicket} className="w-[200px] text-center mt-2 rounded-full  px-3.5 py-2.5 text-sm font-semibold text-[white] cursor-pointer" style={{ background: "rgb(7, 178, 236)" }}>
                        Эрхийн бичиг татах
                      </div>
                    </>
                  }
                  <p style={{ color: "rgb(7, 178, 236)" }} className="font-bold text-[40px] text-center">
                    {eelj?.price}₮
                  </p>
                </div>

                : <div>
                  <div className="w-[200px] text-center mt-2 rounded-full  px-3.5 py-2.5 text-sm font-semibold text-[white] cursor-pointer" style={{ background: "rgb(7, 178, 236)" }}>
                    Эрхийн бичиг үүссэн
                  </div>
                </div>
              }
            </div>
          </div>
        }

        {
          (paymentStatus === PaymentStatus.unpaid || paymentStatus === PaymentStatus.wait || paymentStatus === PaymentStatus.cancelled) && userRole !== 'user' &&
          <div className="w-[200px] text-center mt-2 rounded-full  px-3.5 py-2.5 text-sm font-semibold text-[white] cursor-pointer" style={{ background: "rgb(7, 178, 236)" }}>
            Эрхийн бичиг үүсээгүй
          </div>
        }

        {paymentStatus === PaymentStatus.unpaid && userRole !== 'user' &&
          <div className="lg:w-[200px] sm:w-full text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] bg-red-500">
            Төлбөр төлөгдөөгүй
          </div>
        }
        {paymentStatus === PaymentStatus.wait && userRole === 'user' &&
          <div className="flex max-[600px]:flex-col max-[600px]:items-center">
            <div className="max-[600px]:mt-4 flex flex-col md:flex-row justify-between items-center">
              <p className="text-[#003463] w-full md:w-[40%]">
                Таны худалдан авалт хүлээгдэж байна. QR кодыг уншуулж төлбөрөө төлнө үү.
              </p>
              <div >
                <img src={`data:image/png;base64, ${qpayData.qr_image}`} alt="" />
                <p style={{ color: "rgb(7, 178, 236)" }} className="font-bold text-[40px] text-center">
                  {eelj?.price}₮

                  <br />
                  <a href={qpayData.qPay_shortUrl} target="_blank" className="text-xs underline text-green-400">
                    Аппликэйшнээр төлөх бол энд дарна уу.
                  </a>
                  <br />

                  <div onClick={checkPayment} className="w-[200px] text-center mt-2 rounded-full  px-3.5 py-2.5 text-sm font-semibold text-[white] cursor-pointer" style={{ background: "rgb(7, 178, 236)" }}>
                    Төлбөр шалгах
                  </div>
                </p>
              </div>
              {
                qpayDataIT &&
                <>
                  <div >
                    <img src={`data:image/png;base64, ${qpayDataIT.qr_image}`} alt="" />
                    <p style={{ color: "rgb(7, 178, 236)" }} className="font-bold text-[40px] text-center">
                      {eelj?.ITtrainingPrice}₮

                      <br />
                      <a href={qpayDataIT.qPay_shortUrl} target="_blank" className="text-xs underline text-green-400">
                        Аппликэйшнээр төлөх бол энд дарна уу.
                      </a>
                      <br />


                      <div className="w-[200px] text-center mt-2 rounded-full  px-3.5 py-2.5 text-sm font-semibold text-[white] cursor-pointer" style={{ background: "rgb(7, 178, 236)" }}>
                        Програмчлалын Төлбөр
                      </div>
                    </p>
                  </div>
                </>
              }

            </div>

          </div>
        }
        {paymentStatus === PaymentStatus.cancelled && userRole === 'user' &&
          <div className="lg:w-[200px] sm:w-full text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] bg-red-500">
            Цуцалсан
          </div>
        }
        <div className="flex max-[600px]:flex-col max-[600px]:items-center mb-8">
          <div className="max-[600px]:mt-4 w-full flex flex-col md:flex-row justify-start">
            {userStatus &&
              <div className="flex flex-wrap gap-4">
                <div className="md:w-[auto]">
                  <div className="text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] bg-green-500">
                    Төлөв: {userStatus}
                  </div>
                </div>
                <div className="md:w-[auto]">
                  <div className="text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] bg-green-500">
                    Хамрагдсан бүлэг: {group?.group?.name ?? 'бүлэгт хамрагдаагүй'}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        {userRole !== 'user' && (paymentStatus === PaymentStatus.paid || paymentStatus === PaymentStatus.barter || paymentStatus === PaymentStatus.collective) &&
          <>
            <div className="flex max-[600px]:flex-col max-[600px]:items-center px-4 border-t-4 mt-8">
              <div className="max-[600px]:mt-4 mt-4 w-full flex flex-col md:flex-row justify-start">
                <div className="md:w-[50%]">
                  {(!register || register.length === 0) ?
                    <div onClick={() => { handleUpdateOrder('Бүртгэх'); }} className="w-[200px] text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] cursor-pointer" style={{ background: "rgb(255, 0, 0)" }}>
                      Бүртгэх
                    </div>
                    :
                    <div className="w-[200px] text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] bg-green-500">
                      Бүртгэсэн байна
                    </div>
                  }
                </div>
                <div className="md:w-[50%]">
                  <p>Сүүлчийн бүртгэлүүд</p>
                  {!register || register.length === 0 ?
                    <p>Бүртгэл олдсонгүй</p>
                    :
                    <>
                      <ul>
                        {register.map((r, idx) => {
                          return (
                            <li key={idx} className="list-disc">
                              <p>
                                {r.user?.firstName}, {new Date(r.register_at).toLocaleString('mn')}
                              </p>
                            </li>
                          )
                        })}
                      </ul>
                    </>
                  }
                </div>
              </div>
            </div>
            <div className="flex max-[600px]:flex-col max-[600px]:items-center px-4 border-t-4 mt-8">
              <div className="max-[600px]:mt-4 mt-4 w-full flex flex-col md:flex-row justify-start">
                <div className="md:w-[50%]">
                  <div onClick={() => { handleUpdateOrder('Зусланд ирсэнг бүртгэх'); }} className="w-[200px] text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] cursor-pointer" style={{ background: "rgb(255, 0, 0)" }}>
                    Зусланд ирсэнг бүртгэх
                  </div>
                </div>
                <div className="md:w-[50%]">
                  <p>Сүүлчийн бүртгэлүүд</p>
                  {!register_admin || register_admin.length === 0 ?
                    <p>Бүртгэл олдсонгүй</p>
                    :
                    <>
                      <ul>
                        {register_admin.map((r, idx) => {
                          return (
                            <ul key={idx} className="list-disc">
                              <p>
                                {r.user?.firstName}, {new Date(r.register_at).toLocaleString('mn')}
                              </p>
                            </ul>
                          )
                        })}
                      </ul>
                    </>
                  }
                </div>
              </div>
            </div>
            <div className="flex max-[600px]:flex-col max-[600px]:items-center px-4 border-t-4 mt-8">
              <div className="max-[600px]:mt-4 mt-4 w-full flex flex-col md:flex-row justify-start">
                <div className="md:w-[50%]">
                  <div onClick={() => { handleUpdateOrder('Өөрийн бүлэгт бүртгэх'); }} className="w-[200px] text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] cursor-pointer" style={{ background: "rgb(255, 0, 0)" }}>
                    Өөрийн бүлэгт бүртгэх
                  </div>
                </div>
                <div className="md:w-[50%]">
                  <p>Сүүлчийн бүртгэлүүд</p>
                  {!register_group || register_group.length === 0 ?
                    <p>Бүртгэл олдсонгүй</p>
                    :
                    <>
                      <ul>
                        {register_group.map((r, idx) => {
                          return (
                            <li key={idx} className="list-disc">
                              <p>
                                {r.group?.name ?? 'Бүлэг олдсонгүй'}, {r.user?.firstName}, {new Date(r.register_at).toLocaleString('mn')}
                              </p>
                            </li>
                          )
                        })}
                      </ul>
                    </>
                  }
                </div>
              </div>
            </div>
            <div className="flex max-[600px]:flex-col max-[600px]:items-center px-4 border-t-4 mt-8">
              <div className="max-[600px]:mt-4 mt-4 w-full flex flex-col md:flex-row justify-start">
                <div className="md:w-[50%]">
                  {(userStatus && userStatus === 'Зусланд ирсэн') ?
                    <div onClick={() => { handleUpdateOrder('Хүлээлгэж өгсөн'); }} className="w-[200px] text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] cursor-pointer" style={{ background: "rgb(255, 0, 0)" }}>
                      Хүлээлгэж өгөх
                    </div>
                    :
                    (userStatus && userStatus === 'Хүлээлгэж өгсөн') ?
                      <div className="w-[200px] text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] bg-green-500">
                        Хүлээлгэж өгсөн
                      </div>
                      :
                      <div className="w-[200px] text-center mt-2 rounded-full px-3.5 py-2.5 font-semibold text-[white] bg-gray-500 cursor-not-allowed">
                        Хүлээлгэж өгөх
                      </div>
                  }
                </div>
              </div>
            </div>
          </>
        }
      </div>
      {(paymentStatus === PaymentStatus.paid || paymentStatus === PaymentStatus.barter || paymentStatus === PaymentStatus.collective) &&
        <div className="mt-4 md:flex gap-4">
          <div className="md:w-[50%]">
            <p className="text-[#003463] text-lg font-bold">
              Эрүүл мэндийн үзлэг, үзлэгийн хуудас
            </p>
            <p className="mt-8 text-[#00144799] text-justify">
              Эрүүл мэндийн хуудсыг татан авч Эх хүүхдийн эрүүл мэндийн үндэсний төвийн Зүүн талаас (зурагт)
              хашаагаар ороод 2 давхар Үргүйдэл нөхөн үржихүйн төвийн байранд заавал шинжилгээ
              хийлгэж тэмдэглүүлнэ. Хүүхдийн эмчид үзүүлэх Арьс өнгөний үзлэг Шимэгч
              хорхойн шинжилгээ Шээсний шинжилгээ Ээлжийн эхний өдөр “Найрамдал”
              цогцолборын эмчийн урьдчилан сэргийлэх үзлэгээр тэнцээгүй/ шинжилгээ
              хийлгээгүй, эмчилгээ шаардлагатай өвчлөл илэрсэн/ хүүхдийг өдөрт нь
              эцэг эхэд нь мэдэгдэж, “Гараас гарт” буцаахыг анхаарна уу. Эрүүл
              мэндийн үзлэгийн хуудасыг{" "}
              <a
                target="_blank"
                download="/eruul.pdf"
                className="font-bold text-[#003463]"
                href="/eruul.pdf"
              >
                энд дарж
              </a>{" "}
              татаж авна уу.
            </p>
          </div>
          <div className="md:w-[50%] flex-row">
            {userRole === 'user' ?
              <div className="flex flex-col items-center justify-center w-full mt-5">
                <label
                  htmlFor="dropzone-file"
                  className="flex flex-col items-center justify-center w-full h-64 border-2 border-[#384EB7]/30 border-dashed rounded-lg cursor-pointer bg-[#F8F8F8]"
                >
                  {!healthImg && !healthCertificate ? (
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-10 h-10 mb-3 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                        ></path>
                      </svg>
                      <p className="text-xs text-[#676767]">
                        Supported formates: PNG, JPG (MAX. 800x400px)
                      </p>
                    </div>
                  ) : (
                    <>
                      {healthImg ?
                        <img src={healthImg ? URL.createObjectURL(healthImg) : ''} width={200} height={200} alt="image"></img>
                        :
                        <img src={healthCertificate} width={200} height={200} alt="image"></img>
                      }
                    </>
                  )}
                  <input
                    id="dropzone-file"
                    type="file"
                    className="hidden"
                    accept="image/*"
                    onChange={(e) => {
                      if (e.target.files) {
                        setHealthImg(e.target.files[0]);
                        handleHealthImageUpdate(e.target.files[0]);
                      }
                    }}
                  />
                  <p className="mb-2 text-sm text-[#0F0F0F]">
                    <span className="font-semibold text-[#483EA8] underline">
                      Энд дарж эрүүл мэндийн зургаа шинэчилнэ үү.
                    </span>
                  </p>
                </label>
                {healthImgError && <p className="text-red-500">{healthImgError}</p>}
                {healthImgResponse && <p className="text-green-500">{healthImgResponse}</p>}
              </div>
              :
              <div className="flex flex-col items-center justify-center w-full mt-5">
                {healthCertificate ?
                  <img src={healthCertificate} width={200} height={200} alt="image"></img>
                  :
                  <p>Эрүүл мэндийн үзлэгийн хуудас олдсонгүй</p>
                }
              </div>
            }
          </div>
        </div>
      }
      <div className="mt-6 mb-6 h-[1px] w-full bg-[#00144780]" />
    </div>
  )
};

export default OrderInfo;